import { Box, Typography } from '@material-ui/core';
import { Cake, CakeContent } from '@campfire/cake';
import React from 'react';
import { useCampfireTheme } from '../../theme/useCampfireTheme';

export const SUYPLimbo = ({ preferredName }: { preferredName?: string }) => {
  const { isMobile } = useCampfireTheme();
  return (
    <Box
      width={1}
      height={1}
      display='flex'
      justifyContent='center'
      alignContent='flex-start'
      alignItems='flex-start'
      paddingTop={isMobile ? 3 : 5}
      paddingX={isMobile ? 1 : 2}
      boxSizing='border-box'
    >
      <Box width={1} maxWidth={720}>
        <Cake>
          <CakeContent>
            <Box paddingY={3} paddingX={isMobile ? 1 : 2} textAlign={isMobile ? 'center' : 'start'}>
              <Typography variant='h5' style={{ fontWeight: 'bold' }} gutterBottom>
                <span role='img' aria-label='yay' style={{ marginRight: 16 }}>
                  🎉
                </span>
                {preferredName ? `Thanks, ${preferredName}` : `Profile completed`}
              </Typography>
              <Typography variant='body2' gutterBottom>
                Your profile has been received and is awaiting review!
              </Typography>
              <Typography variant='body2'>
                {`We'll email you as soon as a manager has looked at your profile.`}
              </Typography>
            </Box>
          </CakeContent>
        </Cake>
      </Box>
    </Box>
  );
};
